// ONLY MODIFY THIS FILE BY RUNNING THE FOLLOWING COMMAND:
// php artisan react:enum

export const Timezone = {
  Hawaii: {
    Name: 'Hawaii',
    Value: 'Pacific/Honolulu',
    Label: 'Hawaii',
  },
  Alaska: {
    Name: 'Alaska',
    Value: 'America/Anchorage',
    Label: 'Alaska',
  },
  Pacific: {
    Name: 'Pacific',
    Value: 'America/Los_Angeles',
    Label: 'Pacific',
  },
  Mountain: {
    Name: 'Mountain',
    Value: 'America/Denver',
    Label: 'Mountain',
  },
  Mountain_No_DST: {
    Name: 'Mountain No D S T',
    Value: 'America/Phoenix',
    Label: 'Mountain (no DST)',
  },
  Central: {
    Name: 'Central',
    Value: 'America/Chicago',
    Label: 'Central',
  },
  Central_No_DST: {
    Name: 'Central No D S T',
    Value: 'America/Belize',
    Label: 'Central (no DST)',
  },
  Eastern: {
    Name: 'Eastern',
    Value: 'America/New_York',
    Label: 'Eastern',
  },
  Eastern_No_DST: {
    Name: 'Eastern No D S T',
    Value: 'America/Jamaica',
    Label: 'Eastern (no DST)',
  },
  Atlantic: {
    Name: 'Atlantic',
    Value: 'America/Halifax',
    Label: 'Atlantic',
  },
  Atlantic_No_DST: {
    Name: 'Atlantic No D S T',
    Value: 'America/Puerto_Rico',
    Label: 'Atlantic (no DST)',
  },
  Newfoundland: {
    Name: 'Newfoundland',
    Value: 'America/St_Johns',
    Label: 'Newfoundland',
  },
} as const

export type TimezoneValue = (typeof Timezone)[keyof typeof Timezone]['Value']
